<app-header
  [headerData]="headerData"
  [class.full]="true"
  (searchTerms)="showSearch ? getSearchTerms($event) : null"
  (filterArchiveList)="showFilter ? switchArchiveTab($event) : null"
></app-header>
<app-offline-mode></app-offline-mode>
<ion-content [scrollY]="false">
  <app-orders
    [ordersListData]="ordersListData"
    [tabName]="tabName"
    (totalCount)="getTotalCount($event)"
    class="ion-content-scroll-host"
  ></app-orders>
</ion-content>
